export enum Accessor {
  Index = 'index',
  RepairIssued = 'createdAt',
  Id = 'id',
  Description = 'description',
  Cost = 'cost',
  RepairStatus = 'status',
  Actions = 'actions',
}
